import jsPDF from 'jspdf';
import moment from 'moment';
import rareLogo from '../img/rareLogo';
import clientOverviewImg from '../img/clientOverviewImg';
import industryOverviewImg from '../img/industryOverviewImg';
import { store } from '../../store/store';
import {
  calcBarWidth,
  calculateBadgeOffset,
  calculateTitleXOffset,
  formatDataLabel,
  formatLabel,
  generatePDFfileName,
  hex2rgb,
} from './js/functions';

export default function industryPDFexportNoComp(comparison) {
  const page = 'industry';
  const { dataFormat, currentClient } = store.getters;
  const industryOverviewData = store.getters['$_industry/getIndustryOverviewDataObject']({ comparison, type: 'object', dataFormat });
  const rareMode = (store.getters.clientOrRareMode === 'rare');
  // NOTE: Possible strange behavior on chart width, sometimes it likes to be 200, sometimes 360.
  // Maybe just a glitch, or to do with the industry average distorting the max figure.
  const chartWidth = 360;
  const { data } = industryOverviewData;
  const label = industryOverviewData.labels;
  const rankPosition = label.indexOf(currentClient) + 1;
  const rankTotal = data.length - 1;
  const chartX = 20;
  const totalPages = Math.ceil(Object.keys(data).length / 26);
  const doc = new jsPDF({ orientation: 'p', unit: 'pt', format: 'a4' });
  const filename = generatePDFfileName();
  const title = store.getters.getDisplayNameFromUsername(currentClient);
  const textColors = store.getters.fetchTextColors;
  const barColors = store.getters.fetchBarColors;

  let fromDate = '';
  let toDate = '';
  let organisationPos = 1; // eslint-disable-line
  let chartY = 200;
  let currentPage = 1;
  let clientModeOffset = 0;
  let colorKey = 0;
  let colorLight = '';

  if (comparison === 'base') {
    fromDate = moment(store.getters.fromDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
    toDate = moment(store.getters.toDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
    colorKey = 0;
    colorLight = '#cce4eb';
  } else if (comparison === 'prevYear1') {
    fromDate = moment(store.getters.fromDate, 'YYYY-MM-DD').subtract(1, 'years').format('DD/MM/YYYY');
    toDate = moment(store.getters.toDate, 'YYYY-MM-DD').subtract(1, 'years').format('DD/MM/YYYY');
    colorKey = 1;
    colorLight = '#d6e3b9';
  } else if (comparison === 'prevYear2') {
    fromDate = moment(store.getters.fromDate, 'YYYY-MM-DD').subtract(2, 'years').format('DD/MM/YYYY');
    toDate = moment(store.getters.toDate, 'YYYY-MM-DD').subtract(2, 'years').format('DD/MM/YYYY');
    colorKey = 2;
    colorLight = '#e7bec2';
  } else if (comparison === 'prevYear3') {
    fromDate = moment(store.getters.fromDate, 'YYYY-MM-DD').subtract(3, 'years').format('DD/MM/YYYY');
    toDate = moment(store.getters.toDate, 'YYYY-MM-DD').subtract(3, 'years').format('DD/MM/YYYY');
    colorKey = 3;
    colorLight = '#f1c7af';
  }

  const barBaseColor = hex2rgb(barColors[colorKey]);
  const textBaseColor = hex2rgb(textColors[colorKey]);
  const barLightColor = hex2rgb(colorLight);
  const barAverageColor = hex2rgb('#b4bfc8');
  const textAverageColor = hex2rgb('#7d8b96');
  const textLight = hex2rgb('#4a5b68');
  const textDark = hex2rgb('#323c44');
  const dividerColor = hex2rgb('#dddddd');
  const white = hex2rgb('#ffffff');

  doc.setFont('helvetica', 'normal', 'normal');

  // Header with logo
  doc.setFillColor(textDark.r, textDark.g, textDark.b);
  doc.rect(chartX, 20, 555, 50, 'F');
  doc.addImage(rareLogo, 'PNG', 30, 33, 138, 24);

  if (!rareMode) {
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(18);
    doc.text(title, calculateTitleXOffset(title), 50);
    clientModeOffset = 30;
  }

  // Sub-header with  divider lines and header
  doc.setDrawColor(dividerColor.r, dividerColor.g, dividerColor.b);
  doc.setLineWidth(1);
  doc.line(chartX, 125, 575, 125);

  if (rareMode) {
    doc.addImage(clientOverviewImg, 'PNG', 22, 91, 210, 14);
  } else {
    doc.addImage(industryOverviewImg, 'PNG', 22, 91, 240, 14);
  }

  // Dates and total apps section to the right
  doc.setTextColor(textLight.r, textLight.g, textLight.b);
  doc.setFontSize(10);
  doc.text(397, 100, 'Date Range:');
  doc.setFont('helvetica', 'normal', 'bold');
  doc.text(460, 100, `${fromDate} - ${toDate}`);

  // Subtitle
  doc.setTextColor(textDark.r, textDark.g, textDark.b);
  doc.setFontSize(16);
  doc.setFont('helvetica', 'normal', 'normal');
  if (rareMode) {
    doc.text(19, 160, '1+ FLAG APPLICATIONS');
  } else {
    doc.text(19, 160, 'How many 1+ flag applications do other organisations receive?');
  }

  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal', 'bold');

  if (rareMode === false) {
    doc.text(515, 158, `Rank ${rankPosition}/${rankTotal}`);
  }

  data.forEach((value, key) => {
    const client = label[key];
    const clientDisplayName = formatLabel(label[key]);

    if (label[key] !== 'industry_average') {
      organisationPos += 1;
    }

    doc.setTextColor(textLight.r, textLight.g, textLight.b);
    doc.text(chartX + clientModeOffset, chartY + 2, clientDisplayName);

    doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
    doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);

    if (client === 'industry_average') {
      doc.setFillColor(barAverageColor.r, barAverageColor.g, barAverageColor.b);
      doc.setTextColor(textAverageColor.r, textAverageColor.g, textAverageColor.b);
    } else if (rareMode === false) {
      if (client === currentClient) {
        doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
        doc.ellipse(chartX + 10, chartY, 10, 10, 'F');
        doc.setTextColor(white.r, white.g, white.b);
        doc.text(chartX + calculateBadgeOffset(`${key + 1}`), chartY + 3, `${key + 1}`);
        doc.setTextColor(textLight.r, textLight.g, textLight.b);
        doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
      } else {
        doc.setFillColor(barLightColor.r, barLightColor.g, barLightColor.b);
      }
    }

    doc.rect(chartX + 150, chartY - 7, calcBarWidth(value, chartWidth, page), 14, 'F');
    doc.text(chartX + 520, chartY + 2, formatDataLabel(value));

    if (chartY >= 800) {
      // Page x of y at the bottom of the page
      doc.setTextColor(textLight.r, textLight.g, textLight.b);
      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal', 'normal');
      doc.text(515, 820, `Page ${currentPage} of ${totalPages}`);

      currentPage += 1;

      doc.addPage();
      // Header with logo
      doc.setFillColor(textDark.r, textDark.g, textDark.b);
      doc.rect(chartX, 20, 555, 50, 'F');
      doc.addImage(rareLogo, 'PNG', 30, 33, 138, 24);

      if (!rareMode) {
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(18);
        doc.text(title, calculateTitleXOffset(title), 50);
        clientModeOffset = 30;
      }

      // Sub-header with  divider lines and header
      doc.setDrawColor(dividerColor.r, dividerColor.g, dividerColor.b);
      doc.setLineWidth(1);
      doc.line(chartX, 125, 575, 125);

      if (rareMode) {
        doc.addImage(clientOverviewImg, 'PNG', 22, 91, 210, 14);
      } else {
        doc.addImage(industryOverviewImg, 'PNG', 22, 91, 240, 14);
      }

      // Dates and total apps section to the right
      doc.setTextColor(textLight.r, textLight.g, textLight.b);
      doc.setFontSize(10);
      doc.text(397, 100, 'Date Range:');
      doc.setFont('helvetica', 'normal', 'bold');
      doc.text(460, 100, `${fromDate} - ${toDate}`);

      // Subtitle
      doc.setTextColor(textDark.r, textDark.g, textDark.b);
      doc.setFontSize(16);
      doc.setFont('helvetica', 'normal', 'normal');
      if (rareMode) {
        doc.text(19, 160, '1+ FLAG APPLICATIONS');
      } else {
        doc.text(19, 160, 'How many 1+ flag applications do other organisations receive?');
      }

      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal', 'bold');

      if (rareMode === false) {
        doc.text(515, 158, `Rank ${rankPosition}/${rankTotal}`);
      }

      chartY = 200;
    } else {
      chartY += 24;
    }
  });

  // Page x of y at the bottom of the page
  doc.setTextColor(textLight.r, textLight.g, textLight.b);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal', 'normal');
  doc.text(515, 820, `Page ${currentPage} of ${totalPages}`);

  doc.save(filename);
}
